module.exports = __webpack_public_path__ + "img/icon2.fb9bf426.png";